import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DOM from 'react-dom-factories';

import ImageLoading from './ImageLoading';
import LoadImage from './LoadImage';
import { IMAGE_MAX_BYTES } from '../constants/message';
import ImageLoader from '../lib/react-imageloader';

const styles = {
    wrapper: {
        height: '100%',
        width: '100%',
    },
    clickable: {
        cursor: 'pointer',
    },
};

export default class Image extends Component {
    static propTypes = {
        accentColor: PropTypes.string,
        forceShowLoader: PropTypes.bool.isRequired,
        imageUrl: PropTypes.string,
        loaderClassName: PropTypes.string,
        mediaSize: PropTypes.number,
        onClickUrl: PropTypes.string,
        onError: PropTypes.func,
        onLoad: PropTypes.func,
        preloaderImageUrl: PropTypes.string,
    };

    state = {};

    componentDidMount() {
        this.verifyMediaSize();
    }

    onClick = (e) => {
        const { onClickUrl } = this.props;

        if (onClickUrl) {
            e.preventDefault();
            e.stopPropagation();

            return window.open(onClickUrl, '_blank');
        }
    };

    onImageError = () => {
        const { onError } = this.props;

        if (onError) {
            onError();
        }

        this.setState({
            hasImageFailure: true,
        });
    };

    onImageLoad = (e) => {
        const { onLoad } = this.props;

        if (onLoad) {
            onLoad(e);
        }

        this.setState({
            hasImageFailure: false,
            hasOversizedImage: false,
        });
    };

    verifyMediaSize() {
        const { mediaSize } = this.props;

        if (mediaSize > IMAGE_MAX_BYTES) {
            this.setState({
                hasOversizedImage: true,
            });
        }
    }

    render() {
        const {
            accentColor,
            imageUrl,
            loaderClassName,
            mediaSize,
            onClickUrl,
            preloaderImageUrl,
            forceShowLoader,
        } = this.props;
        const { hasImageFailure, hasOversizedImage } = this.state;

        const preloader = () => {
            return (
                <div className="preloader-container">
                    <ImageLoading color={accentColor} />
                    {preloaderImageUrl ? <img src={preloaderImageUrl} alt="Uploaded image" /> : null}
                </div>
            );
        };

        const wrapperStyles = Object.assign({}, styles.wrapper);

        if (onClickUrl) {
            Object.assign(wrapperStyles, styles.clickable);
        }

        const shouldLoadImage = imageUrl && !hasImageFailure && !hasOversizedImage;

        const imagePart = shouldLoadImage ? (
            <ImageLoader
                src={imageUrl}
                imgProps={{ alt: 'Uploaded image' }}
                wrapper={DOM.div}
                preloader={preloader}
                onError={this.onImageError}
                onLoad={this.onImageLoad}
                forceShowLoader={forceShowLoader}
                className={loaderClassName}
            />
        ) : (
            <LoadImage
                className="image-placeholder"
                hasFailedToLoad={hasImageFailure}
                mediaSize={mediaSize}
                onLoadImage={this.onImageLoad}
            />
        );

        return (
            <div className="image-container" onClick={this.onClick} style={wrapperStyles}>
                {imagePart}
            </div>
        );
    }
}
